<app-theme-option [categories]="themeOptions.optionsConfiguration[optionType].categories" [label]="themeOptions.optionsConfiguration[optionType].label" [information]="'PIXELS'">
  <div app-theme-option-content>
    <app-number [value]="themeOptions.options().gauge.pointerOptions.toplength" (sendValue)="receiveValue($event)" [color]="color" [min]="-34" [max]="6" [step]="2"></app-number>
  </div>
</app-theme-option>